import { render, staticRenderFns } from "./LazyImageScaleable.vue?vue&type=template&id=f24c8f32&"
import script from "./LazyImageScaleable.vue?vue&type=script&lang=ts&"
export * from "./LazyImageScaleable.vue?vue&type=script&lang=ts&"
import style0 from "./LazyImageScaleable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports